module.exports = __webpack_public_path__ + "img/x.c5f6f3a7.svg";